import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import reactStringReplace from 'react-string-replace';

import styles from './index.scss';

const suggestionClasses = classNames({
    [styles.suggestion]: true,
    'analytics-keyword-suggestion': true,
});
const Suggestion = ({ suggestion: { href, text, tag }, searchValue }) => {
    /**
     * Wraps search string with special markup
     * @param responseText {String} - autosuggestion from server response
     * @param selectedValue {String} - search string in search input
     * @returns {String|Object} - preact node or string
     */
    const highlightSelectedValue = (responseText, selectedValue) => {
        let inputText = selectedValue.toLowerCase();
        const highlighted = responseText.toLowerCase();

        if (highlighted.indexOf(inputText) !== -1) {
            const index = highlighted.indexOf(inputText);
            inputText = responseText.substr(index, inputText.length);

            return reactStringReplace(responseText, inputText, value => (
                <span className={styles.suggestion__selectedValue}>{value.toUpperCase()}</span>
            ));
        }

        return responseText;
    };

    return (
        <li className={suggestionClasses} data-item-name={tag}>
            <a href={href} className={styles.suggestion__link}>
                {highlightSelectedValue(text, searchValue)}
            </a>
        </li>
    );
};

Suggestion.propTypes = {
    suggestion: PropTypes.shape({
        href: PropTypes.string,
        text: PropTypes.string,
        tag: PropTypes.string,
    }).isRequired,
    searchValue: PropTypes.string.isRequired,
};

export default Suggestion;
